import { createTheme, Theme } from '@mui/material/styles';

const HEI_YELLOW = '#F5C200';

export const lightTheme: Theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: HEI_YELLOW, contrastText: '#0D0D0D' },
    secondary: { main: '#0D0D0D' },
    background: { default: '#F2F2F2', paper: '#FFFFFF' },
    text: { primary: '#1A1A1A', secondary: '#6B6B6B' },
    divider: 'rgba(0,0,0,0.08)',
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Inter", "Segoe UI", Arial, sans-serif',
    fontSize: 14,
  },
  components: {
    MuiModal: {
      defaultProps: {
        disableEscapeKeyDown: true,
      },
    },
    MuiDialog: {
      defaultProps: {
        disableEscapeKeyDown: true,
        // Ignora el clic en el fondo: solo cierran los botones del diálogo
        onClose: (_event: any, reason: string) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return false;
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
          border: '1px solid rgba(0,0,0,0.06)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600, fontSize: 12 },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, borderRadius: 8 },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-root': {
            backgroundColor: '#1A1A1A',
            color: '#FFFFFF',
            fontWeight: 600,
          },
        },
      },
    },
  },
});

export const darkTheme: Theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: HEI_YELLOW, contrastText: '#0D0D0D' },
    secondary: { main: '#F5F5F5' },
    background: {
      default: '#1C1C1E',
      paper: '#2C2C2E',
    },
    text: {
      primary: '#F5F5F5',
      secondary: '#A0A0A0',
    },
    divider: 'rgba(255,255,255,0.08)',
    error: { main: '#FF453A' },
    success: { main: '#30D158' },
    warning: { main: '#FFD60A' },
    info: { main: '#0A84FF' },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Inter", "Segoe UI", Arial, sans-serif',
    fontSize: 14,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#2C2C2E',
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
          border: '1px solid rgba(255,255,255,0.06)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#2C2C2E',
          backgroundImage: 'none',
        },
      },
    },
    MuiModal: {
      defaultProps: {
        disableEscapeKeyDown: true,
      },
    },
    MuiDialog: {
      defaultProps: {
        disableEscapeKeyDown: true,
        onClose: (_event: any, reason: string) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return false;
        },
      },
      styleOverrides: {
        paper: { backgroundColor: '#2C2C2E' },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: { backgroundColor: '#2C2C2E' },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(255,255,255,0.06)',
          color: '#F5F5F5',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(even)': { backgroundColor: 'rgba(255,255,255,0.03)' },
          '&:nth-of-type(odd)': { backgroundColor: 'transparent' },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-root': {
            backgroundColor: '#141414',
            color: '#F5F5F5',
            fontWeight: 600,
            borderColor: 'rgba(255,255,255,0.06)',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600, fontSize: 12 },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, borderRadius: 8 },
        outlinedInherit: { borderColor: 'rgba(255,255,255,0.2)' },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
            '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: { color: '#A0A0A0' },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { backgroundColor: 'rgba(255,255,255,0.05)' },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: { borderColor: 'rgba(255,255,255,0.08)' },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: { color: '#A0A0A0' },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: { backgroundColor: HEI_YELLOW },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: '#A0A0A0',
          '&.Mui-selected': { color: HEI_YELLOW },
        },
      },
    },
  },
});